

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const TOGGLEEMPLOYEESTATUS= createAsyncThunk(
  "toggleEmployeeStatus/toggleEmployeeStatus",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const toggleEmployeeStatusSlice = createSlice({
  name: "toggleEmployeeStatusSlice",
  initialState: {
    toggleEmployeeStatus: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOftoggleEmployeeStatus: (state) => {
        state.toggleEmployeeStatus.loading = false
        state.toggleEmployeeStatus.error = false
        state.toggleEmployeeStatus.data = []
        state.toggleEmployeeStatus.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(TOGGLEEMPLOYEESTATUS.fulfilled, (state, action) => {
      state.toggleEmployeeStatus = {
        ...state.toggleEmployeeStatus,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(TOGGLEEMPLOYEESTATUS.pending, (state, action) => {
      state.toggleEmployeeStatus = {
        ...state.toggleEmployeeStatus,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(TOGGLEEMPLOYEESTATUS.rejected, (state, action) => {
      state.toggleEmployeeStatus = {
        ...state.toggleEmployeeStatus,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const toggleEmployeeStatusAction = {
    TOGGLEEMPLOYEESTATUS,
};

export { toggleEmployeeStatusAction };
export default toggleEmployeeStatusSlice.reducer;
export const {setInitialStateOftoggleEmployeeStatus} = toggleEmployeeStatusSlice.actions
